import classNames from 'classnames'
import {
  Maybe,
  CampaignType,
} from '@dustin-web/microsite-data/src/graphql/product/generated/graphql-types'

export type PriceType = {
  campaignPercentage?: Maybe<number>
  campaignType?: Maybe<CampaignType>
  isBestSeller: boolean
  isBid: boolean
  isCampaign: boolean
  isRecommendedProduct: boolean
}

export type Props = {
  price?: Maybe<PriceType>
  isNewProduct: boolean
  isCampaignProduct?: boolean
  description?: string
  isBlackWeek?: boolean
  text: {
    [key: string]: string
  }
}

export const ProductBadge = ({
  price,
  isNewProduct,
  isCampaignProduct = false,
  description,
  isBlackWeek,
  text,
}: Props) => {
  const badgeArray = [] as { infoClass: string; description: string }[]
  if (isBlackWeek) {
    badgeArray.push({
      infoClass: 'c-product-badge--black-week',
      description: text.blackFriday,
    })
  }

  if (price?.isCampaign) {
    switch (price.campaignType) {
      case CampaignType.NewLowerPrice:
        badgeArray.push({
          infoClass: 'c-product-badge--bg-light-red',
          description: text.newLowerPrice,
        })
        break
      case CampaignType.LimitedBatch:
        // product cards have white badges in this instance.Should these be the same?
        badgeArray.push({
          infoClass: 'c-product-badge--bg-light-red',
          description: text.limitedBatch,
        })
        break
      case CampaignType.Campaign:
      default:
        badgeArray.push({
          infoClass: 'c-product-badge--bg-pop-red',
          description: `-${price.campaignPercentage?.toString() ?? ''}%`,
        })
        break
    }
  } else if (price?.isBid) {
    // ? Should these badges be white, gray, or red?
    badgeArray.push({
      infoClass: 'c-product-badge--bg-light-red',
      description: text.isBidPrice,
    })
  } else if (isNewProduct) {
    badgeArray.push({
      infoClass: 'c-product-badge--bg-pop-yellow',
      description: text.newBadge,
    })
  } else if (isCampaignProduct) {
    badgeArray.push({
      infoClass: 'c-product-badge--campaign',
      description: `${description}`,
    })
  } else if (price?.isBestSeller) {
    badgeArray.push({
      infoClass: 'c-product-badge--bg-pop-yellow',
      description: text.topSeller,
    })
  } else if (price?.isRecommendedProduct) {
    badgeArray.push({
      infoClass: 'c-product-badge--bg-pop-yellow',
      description: text.recommended,
    })
  }

  if (!badgeArray.length) return null

  const badgeMarkup = badgeArray.map((badge, key) => (
    <div
      key={badge.description + key}
      className={classNames('c-product-badge', badge.infoClass, {
        'c-product-badge--last': badgeArray.length === key + 1,
      })}>
      <span className="c-product-badge__text">{badge.description}</span>
    </div>
  ))

  return <>{badgeMarkup}</>
}

export default ProductBadge
